import { Namespace, useT } from "@racoon/i18n";
import { Button, Input } from "@racoon/ui";
import { ArrowUp } from "lucide-react";

export const ChatActions = ({
  input,
  onInputChange,
  onSend,
  loading,
}: {
  input: string;
  onInputChange: (value: string) => void;
  onSend: () => void;
  loading: boolean;
}) => {
  const t = useT();

  return (
    <div className="flex justify-between items-center gap-4">
      <div className="flex flex-1 items-center gap-2">
        <Input
          id="chat-actions-input"
          className="!bg-[#F2F4F7] rounded-[100px] border-none !h-8"
          placeholder={t(Namespace.Chat, "askQuestion")}
          value={input}
          onChange={(e) => onInputChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !loading) onSend();
          }}
          disabled={loading}
        />
        <div>
          <Button
            id="chat-actions-send-button"
            className="!w-8 !h-8 rounded-[200px] flex items-center justify-center !p-0"
            onClick={onSend}
            disabled={loading || !input}
          >
            <ArrowUp className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};
